import { Interval, isSameDay } from 'date-fns';
import { useWeekCalendar } from '../../../hooks/useWeekCalendar';
import { Button } from '../../atoms/Button';
import { Typography } from '../../molecules/Typography';
import { WeekCalendarDayButton } from '../../molecules/WeekCalendarDayButton';

interface iWeekCalendarProps {
  onSelectDate?: (date: Date, interval: Interval) => void;
}

function WeekCalendar({ onSelectDate }: iWeekCalendarProps) {
  const {
    monthYearLabel,
    weekDatesInterval,
    selectedDate,
    handlePrevWeek,
    handleNextWeek,
    handleSelectDate,
  } = useWeekCalendar(onSelectDate);

  return (
    <div className='flex w-full flex-col gap-6'>
      <div>
        <Typography type='title' size='h3'>
          {monthYearLabel}
        </Typography>
      </div>
      <div className='flex'>
        <Button
          variant='text'
          LeftIcon={'arrow_back_ios'}
          iconType='material'
          iconSize='small'
          className='px-0'
          onlyIcon
          onClick={handlePrevWeek}
        />

        <div className='flex w-full gap-sm'>
          {weekDatesInterval.map((date, index) => (
            <WeekCalendarDayButton
              date={date}
              key={index}
              onClick={() => {
                handleSelectDate(date);
              }}
              selected={isSameDay(date, selectedDate)}
            />
          ))}
        </div>

        <Button
          variant='text'
          LeftIcon={'arrow_forward_ios'}
          iconType='material'
          iconSize='small'
          className='px-0'
          onlyIcon
          onClick={handleNextWeek}
        />
      </div>
    </div>
  );
}

export { WeekCalendar };
